import { Select } from 'antd';
import React from 'react';
import './index.less';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleSelectChange = (value: string) => {
    // 检查是否是URL（包含域名）
    if (
      value.startsWith('http://') ||
      value.startsWith('https://') ||
      value.includes('.')
    ) {
      window.open(value, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="custom-footer">
      <div className="footer-bottom">
        <div
          className="footer-logo"
          style={{ textAlign: 'center', marginBottom: '5px' }}
        >
          <img
            src="/assets/footer-logo@2x.png"
            style={{ width: '300px', height: 'auto' }}
          />
        </div>
        <div className="footer-copyright">
          <p>
            地址：北京市西城区德胜门东滨河路3号 白孔雀艺术世界A座四层 |
            邮政编码：100120 | 电话：010-62016691
          </p>
          <p>主办：中关村中安安防产业发展促进会</p>
          <p>
            © {currentYear} 版权所有：中关村中安安防产业发展促进会 |{' '}
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              京ICP备2025131079号-2
            </a>{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
